export function NoChartData(props: { height: number; label: string }) {
	return (
		<div
			className="w-full mt-6 border-2 border-gray-200 flex items-center justify-center bg-gray-100"
			style={{
				height: props.height,
			}}>
			<p>{props.label}</p>
		</div>
	);
}
